

export enum SteadyConsultStatus {
  // Scheduled consult states
  received = "received",
  unassigned = "unassigned",
  assigned = "assigned",
  scheduled = "scheduled",
  clinician_change = "clinician_change",
  ready_to_resume = "ready_to_resume",
  // Consult in progress states
  in_progress = "in_progress",
  in_review = "in_review",
  in_call = "in_call",
  external_in_progress = "external_in_progress", // Not used by us
  // Consult waiting for patient action
  waiting_to_schedule = "waiting_to_schedule",
  waiting = "waiting",
  waiting_for_intake = "waiting_for_intake",
  // Consult end states
  canceled = "canceled",
  rejected = "rejected",
  completed = "completed",
  referred_out = "referred_out",
  // Lab consult specific states
  lab_approved = "lab_approved",
  lab_denied = "lab_denied",
  lab_results_ready = "lab_results_ready",
  lab_completed = "lab_completed",
  lab_rejected = "lab_rejected",
  lab_results_received = "lab_results_received",
}

// Should be in sync with growth enum:
// https://github.com/noom/growth/blob/3535e02819260e399ffec70b3cc1079d12ed7e0a/apps/telehealth/constants.py#L226
export enum SteadyLaboratory {
  LAB_CORP = "LAB_CORP",
  QUEST = "QUEST",
  GENERIC = "GENERIC",
}

export const steadyUnfinishedConsultStatuses = [
  SteadyConsultStatus.received,
  SteadyConsultStatus.unassigned,
  SteadyConsultStatus.assigned,
  SteadyConsultStatus.scheduled,
  SteadyConsultStatus.clinician_change,
  SteadyConsultStatus.ready_to_resume,
  SteadyConsultStatus.in_progress,
  SteadyConsultStatus.in_review,
  SteadyConsultStatus.in_call,
  SteadyConsultStatus.external_in_progress,
  SteadyConsultStatus.waiting,
  SteadyConsultStatus.waiting_for_intake,
];

export enum SteadyConsultType {
  async_lab_order = "async_lab_order",
  async_lab_result = "async_lab_result",
  async_messaging = "async_messaging",
  initial_video_visit = "initial_video_visit",
  lab_result_scheduled_video = "lab_result_scheduled_video",
  follow_up_video = "followup_video_visit",
}

export const steadyVideoConsultTypes = [
  SteadyConsultType.initial_video_visit,
  SteadyConsultType.lab_result_scheduled_video,
  SteadyConsultType.follow_up_video,
];

export enum ConsultDisposition {
  diagnosed = "diagnosed",
  referredOut = "referred-out",
  providerNoShow = "provider-no-show",
  patientNoShow = "patient-no-show",
  otherCancellation = "other-cancellation",
  patientCancellation = "patient-cancellation",
  providerCancellation = "provider-cancellation",
}

const MIXPANEL_NAMESPACE = "PatientCenter";

export const MixpanelTypes = {
  OnVisitsPage: `${MIXPANEL_NAMESPACE}_OnVisitsPage`,
  OnPrescriptionsPage: `${MIXPANEL_NAMESPACE}_OnPrescriptionsPage`,
  OnShippingAndRefillsPage: `${MIXPANEL_NAMESPACE}_OnShippingAndRefillsPage`,
  OnUpdateRefillPage: `${MIXPANEL_NAMESPACE}_OnUpdateRefillPage`,
  LoginSuccessful: `${MIXPANEL_NAMESPACE}_LoginSuccessful`,
  LoginFailed: `${MIXPANEL_NAMESPACE}_LoginFailed`,
  ScheduleConsultRedirect: `${MIXPANEL_NAMESPACE}_ScheduleConsultRedirect`,
  LabFileSelected: `${MIXPANEL_NAMESPACE}_LabFileSelected`,
  LabUploadError: `${MIXPANEL_NAMESPACE}_LabUploadError`,
  LabUploadSuccess: `${MIXPANEL_NAMESPACE}_LabUploadSuccess`,
  RefillUpdateConfirmed: `${MIXPANEL_NAMESPACE}_RefillUpdateConfirmed`,
  RefillUpdateCancelled: `${MIXPANEL_NAMESPACE}_RefillUpdateCancelled`,
  RefillUpdateError: `${MIXPANEL_NAMESPACE}_RefillUpdateError`,
  PharmacySwitchConfirmed: `${MIXPANEL_NAMESPACE}_PharmacySwitchConfirmed`,
  ConcentrationChangeConfirmed: `${MIXPANEL_NAMESPACE}_ConcentrationChangeConfirmed`,
  ConcentrationChangeIncreaseConfirmed: `${MIXPANEL_NAMESPACE}_ConcentrationChangeIncreaseConfirmed`,
  CompoundFormulationChangeConfirmed: `${MIXPANEL_NAMESPACE}_CompoundFormulationChangeConfirmed`,
  AppError: `${MIXPANEL_NAMESPACE}_AppError`,
  OnNotFoundPage: `${MIXPANEL_NAMESPACE}_OnNotFoundPage`,
} as const;

export enum PatientType {
  OTHER = "other",
  STEADYMD = "steadymd",
}

export const PROCESSED_LAB_ORDER_STATUSES = [
  SteadyConsultStatus.lab_completed,
  SteadyConsultStatus.lab_results_ready,
  SteadyConsultStatus.lab_results_received,
];
